var map = {
	"./LT.png": 50486,
	"./culver.png": 15485,
	"./godrej_housing_finance.png": 73040,
	"./hdfc_life_insurance.png": 73843,
	"./mrf.png": 76089,
	"./muthoot_housing_finance.png": 57239,
	"./pidilite.png": 65782,
	"./reliance.png": 48913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40068;